var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#100F15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 20C14 20.55 13.55 21 13 21C12.45 21 12 20.55 12 20V16C12 15.45 12.45 15 13 15C13.55 15 14 15.45 14 16V20ZM20 20C20 20.55 19.55 21 19 21C18.45 21 18 20.55 18 20V16C18 15.45 18.45 15 19 15C19.55 15 20 15.45 20 16V20ZM22 23C22 23.551 21.552 24 21 24H11C10.448 24 10 23.551 10 23V12H22V23ZM14 8.328C14 8.173 14.214 8 14.5 8H17.5C17.786 8 18 8.173 18 8.328V10H14V8.328ZM25 10H24H20V8.328C20 7.044 18.879 6 17.5 6H14.5C13.121 6 12 7.044 12 8.328V10H8H7C6.45 10 6 10.45 6 11C6 11.55 6.45 12 7 12H8V23C8 24.654 9.346 26 11 26H21C22.654 26 24 24.654 24 23V12H25C25.55 12 26 11.55 26 11C26 10.45 25.55 10 25 10Z",
    fill: "#100F15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.dc922f0c949a51e8ad995e19a325e247.svg";
export { ForwardRef as ReactComponent };